import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=527ef0fd&scoped=true&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=527ef0fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ef0fd",
  null
  
)

export default component.exports